import { useEffect } from "react";

// Adds a subtle staggered fade/slide-in as elements enter the viewport.
export default function useScrollReveal(deps = []) {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const sel = "[data-reveal], section h1, section h2, section h3, .eyebrow, .card-brutal, main img";
    const els = Array.from(document.querySelectorAll(sel));
    els.forEach((el) => {
      if (!el.classList.contains("will-reveal")) el.classList.add("will-reveal");
    });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach((el) => {
      const siblings = Array.from(el.parentElement ? el.parentElement.children : []);
      const idx = siblings.indexOf(el);
      el.style.transitionDelay = `${Math.min(idx, 5) * 60}ms`;
      io.observe(el);
    });
    // reveal anything already in view on load
    requestAnimationFrame(() => {
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) el.classList.add("in");
      });
    });
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
